export const SET_VOUCHER_CODE_FIELD = 'SET_VOUCHER_CODE_FIELD'
export const SET_VOUCHER_CODE = 'SET_VOUCHER_CODE'
export const APPLY_VOUCHER_CODE = 'APPLY_VOUCHER_CODE'
export const APPLY_VOUCHER_CODE_FAIL = 'APPLY_VOUCHER_CODE_FAIL'
export const CANCEL_VOUCHER_CODE = 'CANCEL_VOUCHER_CODE'
export const RECEIVE_VOUCHER_CODE = 'RECEIVE_VOUCHER_CODE'

export function showVoucherCodeField () {
  return {
    type: SET_VOUCHER_CODE_FIELD,
    payload: {
      item: true
    }
  }
}

export function setVoucherCode (voucherCode) {
  return {
    type: SET_VOUCHER_CODE,
    payload: {
      item: voucherCode
    }
  }
}

export function applyVoucherCode (result) {
  return {
    type: APPLY_VOUCHER_CODE,
    payload: {
      result
      }
  }
}

export function applyVoucherCodeFail (minPurchase) {
  return {
    type: APPLY_VOUCHER_CODE_FAIL,
    payload: {
      minPurchase: minPurchase
    }
  }
}

export function cancelVoucherCode () {
  return {
    type: CANCEL_VOUCHER_CODE
  }
}

export function receiveVoucherCode (json, items, country, postCode) {
  return {
    type: RECEIVE_VOUCHER_CODE,
    payload: {
      item: {
        ...json,
        lowestShippingMethod: json.shipping.length > 1 ? json.shipping.reduce((prev, cur) => {
          return prev.delivery_charges < cur.delivery_charges ? prev : cur;
        }) : json.shipping[0]
      },
      country,
      postCode,
      items,
      receivedAt: Date.now()}
  }
}
